"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortCountriesByList = exports.getItemValue = exports.createPreset = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _presets = require("@otpusk/apisearch-toolbox/dist/queries/presets");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var countryMapper = function countryMapper(_ref) {
  var id = _ref.id,
    currency = _ref.currency,
    transport = _ref.transport,
    name = _ref.name;
  return {
    value: {
      countryID: id,
      currency: currency,
      transport: transport
    },
    content: name
  };
};
var sortCountriesByList = exports.sortCountriesByList = function sortCountriesByList(countries) {
  var importantCountries = R.call(R.pipe(R.filter(R.prop('weight')), R.sort(R.descend(R.prop('weight'))), R.map(countryMapper)), countries);
  var defaultCountries = R.call(R.pipe(R.filter(function (_ref2) {
    var weight = _ref2.weight;
    return !weight;
  }), R.sort(function (_ref3, _ref4) {
    var a = _ref3.name;
    var b = _ref4.name;
    return a.localeCompare(b);
  }), R.map(countryMapper)), countries);
  return R.concat([{
    content: '',
    divider: true,
    subItems: importantCountries
  }], defaultCountries);
};
var createPreset = exports.createPreset = function createPreset(countryID) {
  var BASE_QUERY = (0, _fn.createQuery)().toJS();
  var availabilities = (0, _presets.getAvailabilitiesByCountry)(countryID);
  return R.concat(R.call(R.cond([[function (id) {
    return R.includes(id, ['43', '115']);
  }, R.always([{
    paramName: _fn.QUERY_PARAMS.CATEGORY,
    paramValue: R.mergeAll([R.mapObjIndexed(R.F, BASE_QUERY[_fn.QUERY_PARAMS.CATEGORY]), {
      4: true,
      5: true
    }])
  }, {
    paramName: _fn.QUERY_PARAMS.FOOD,
    paramValue: R.mergeAll([R.mapObjIndexed(R.F, BASE_QUERY[_fn.QUERY_PARAMS.FOOD]), {
      ai: true,
      uai: true
    }])
  }])], [R.T, R.always([{
    paramName: _fn.QUERY_PARAMS.CATEGORY,
    paramValue: R.mapObjIndexed(R.F, BASE_QUERY[_fn.QUERY_PARAMS.CATEGORY])
  }, {
    paramName: _fn.QUERY_PARAMS.FOOD,
    paramValue: R.mapObjIndexed(R.F, BASE_QUERY[_fn.QUERY_PARAMS.FOOD])
  }])]]), countryID), R.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      paramName = _ref6[0],
      paramValue = _ref6[1];
    return {
      paramName: paramName,
      paramValue: paramValue
    };
  }, R.toPairs(availabilities)));
};
var getItemValue = exports.getItemValue = function getItemValue(items, selectedCountryID) {
  return R.call(R.pipe(R.concat, R.find(function (_ref7) {
    var value = _ref7.value;
    return value.countryID === selectedCountryID;
  }), R.prop('value')), items[0].subItems, R.remove(0, 1, items));
};